import { LoginComponent } from './../login/login.component';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SmartRuralAuthCompComponent } from './smart-rural-auth-comp/smart-rural-auth-comp.component';


export const routes: Routes = [
  // .. here goes our components routes
  {
  path: '',
  component: SmartRuralAuthCompComponent,
  children: [
    {
      path: 'login',
      component: LoginComponent,
    }
  ]
  }
];

/**
 * Módulo que implementa el enruta de autenticación
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
